/**
 * Must be small enough to load fast, but big enough for the image to be
 * minimally recognizable, otherwise it looks like a wird giant blur
 */
export const filestackLoadingSrcRatio = 0.025 as const;

/**
 * Must be small enough to load fast, but big enough for the image to preserve
 * the colors and shape so that it's minimally recognizable
 */
export const filestackLoadingSrcQuality = 10 as const;

/**
 * We're loading a very small and low quality image, blurring it makes it look
 * like a blur. We want this value to be small enough to keep the image silhouette
 * but big enough to not look pixelated when scaled.
 */
export const filestackLoadingSrcBlur = 2 as const;
